<template>
  <div class="recognize-panel-box">
    <div class="recognize-panel-left-box">
      <div class="left-text-box">
        <el-col
          :span="20"
          style="display: flex; justify-content: center; margin-top: 60px"
        >
          <!-- <el-upload
            class="avatar-uploader"
            action="/bms/vehicleReservation/ocrImagesParsing.json"
            :on-success="handleFileSuccess"
            :file-list="fileList"
            :show-file-list="true"
            :multiple="false"
            :limit="1"
            :headers="fileUploadHeaders"
            accept="image/png,image/jpg,image/jpeg"
            list-type="picture"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :before-upload="handleBeforeUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload> -->
          <div class="upload-img-item">
            <el-upload
              v-if="!imageUrl"
              action="/bms/vehicleReservation/ocrImagesParsing.json"
              :headers="fileUploadHeaders"
              accept="image/png,image/jpg,image/jpeg"
              list-type="picture-card"
              :show-file-list="false"
              :multiple="false"
              :limit="1"
              :on-success="handleFileSuccess"
              :on-exceed="handleExceed"
              :before-upload="handleBeforeUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-else class="img-card">
              <img class="img" :src="imgPath(imageUrl)" />
              <div class="delete-icon">
                <i class="el-icon-delete" @click="onRemoveFile"></i>
              </div>
            </div>
          </div>
        </el-col>
        <div class="format-box">支持格式: jpg, png 单个文件不超过5MB.</div>
        <div style="margin-top: 20px; height: calc(100% - 300px)">
          <el-input
            style="width: 95%"
            v-model="text"
            type="textarea"
            :rows="14"
            clearable
            placeholder="OCR图片识别信息"
          ></el-input>
        </div>
      </div>
      <!-- <el-button
        type="primary"
        style="position: absolute; bottom: 5%; left: 22%"
        @click="ocrRecognizeOpt"
        >OCR识别</el-button
      > -->
    </div>
    <div class="recognize-panel-middle-box">
      <!-- <div style="text-align: center; margin-bottom: 30px">
        <img
          src="@src/common/assets/images/arrows_left.png"
          style="cursor: pointer"
          alt=""
          @click="changePictureOpt"
        />
      </div> -->
      <div style="text-align: center">
        <img
          src="@src/common/assets/images/arrows_right.png"
          alt=""
          @click="changeTextOpt"
        />
      </div>
    </div>
    <div class="recognize-panel-right-box">
      <el-form
        style="height: 85%; margin-top: 5%"
        :inline="true"
        :model="recognizeInfo"
        :rules="rules"
        ref="refForm"
        label-width="130px"
        label-position="right"
        label-suffix=" ："
      >
        <el-scrollbar style="height: 100%">
          <div>
            <el-col :span="24">
              <el-form-item label="柜号" prop="cabinetNumberPage">
                <el-input
                  v-model="recognizeInfo.cabinetNumberPage"
                  clearable
                  placeholder="请输入柜号"
                ></el-input>
                <!-- @paste.native.capture.prevent="handlePaste" -->
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="作业类型" prop="operateType">
                <el-radio-group v-model="recognizeInfo.operateType">
                  <el-radio :label="1">装货</el-radio>
                  <el-radio :label="2">卸货</el-radio>
                  <el-radio :label="3">过车</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="recognizeInfo.operateType == 3">
              <el-form-item label="操作类型" prop="passType">
                <el-radio-group v-model="recognizeInfo.passType">
                  <el-radio :label="1">倒入</el-radio>
                  <el-radio :label="2">倒出</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="客户名称">
                <el-input
                  v-model="recognizeInfo.custom"
                  clearable
                  placeholder="请输入客户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="司机姓名">
                <el-input
                  v-model="recognizeInfo.driverName"
                  clearable
                  placeholder="请输入司机姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="电话">
                <el-input
                  v-model="recognizeInfo.phone"
                  clearable
                  placeholder="请输入电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="前车车牌">
                <el-input
                  v-model="recognizeInfo.frontPlate"
                  clearable
                  placeholder="请输入前车车牌"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="货品名称">
                <el-input
                  clearable
                  v-model="recognizeInfo.waresName"
                  placeholder="请输入货品名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="数量">
                <el-input
                  clearable
                  v-model="recognizeInfo.waresCount"
                  placeholder="请输入数量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="重量">
                <el-input
                  clearable
                  v-model="recognizeInfo.waresWeight"
                  placeholder="请输入重量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="预约到达时间" prop="estimatedArrivalTime">
                <el-date-picker
                  clearable
                  v-model="recognizeInfo.estimatedArrivalTime"
                  type="date"
                  placeholder="请选择预约到达时间"
                  style="width: 100%"
                  format="yyyy/MM/dd"
                  value-format="yyyy/MM/dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </div>
        </el-scrollbar>
      </el-form>
      <el-button
        type="primary"
        style="position: absolute; bottom: 5%; right: 22%"
        @click="saveTextOpt"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import utils from "@src/common/utils";
import { Bus, Cache, Log } from "$utils";

export default {
  props: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    const validateNumber = (rule, value, callback) => {
      var reg = new RegExp("^[0-9]+$");
      if (!reg.test(value)) {
        callback(new Error("格式不正确"));
      } else {
        callback();
      }
    };
    return {
      fileList: [],
      recognizeInfo: {
        appointmentId: null,
        appointmentUuid: null /**车辆预约UUID*/,
        driverId: null /**司机ID*/,
        driverName: "" /**姓名*/,
        phone: "" /**手机号码*/,
        vehicleId: null /**车辆ID*/,
        frontPlate: "", // 前车车牌
        trailerPlate: "", //后车车牌
        appointmentType: null /**进出类型：1：进门，2：出门*/,
        operateType: null /**操作类型：1：装货、2：卸货、3：过车*/,
        passType: null /**过车类型：1：倒入，2：倒出*/,
        appointmentPark: "" /**预约园区ID*/,
        estimatedArrivalTime: "" /**预计到达时间*/,
        custom: "" /**客户*/,
        cabinetNumber: "" /**货柜数量*/,
        cabinetNumberPage: "", // 页面展示的柜号
        waresName: "", // 货物名称
        waresCount: "", // 货品数量
        waresWeight: "", // 货品重量
        serialNumber: "" /**流水号*/,
        appointmentStatus: null, // 状态
        picture: "" /**司机照片*/,
        frontLicensePlatePicture: "" /**前车牌照片*/,
        trailerLicensePlatePicture: "" /**挂车牌照片*/,
        carPicture: "" /**车身照片*/,
        companyCode: "" /**公司编号*/,
        specialProductFlag: "" /**是否特殊商品 1：是；0：否*/,
        isPauseWork: "" /**是否暂停作业 1：是；0：否*/,
        dataSource: "" /**数据来源 1：客服录入；0：司机预约*/,
        refAppointmentUuid: "" /**倒柜车辆预约UUID*/,
        creator: "" /**创建人(登录账号)*/,
        createTime: "" /** 创建时间 */,
        modifier: "", // 修改人(登录账号)
        modifyTime: "" /** 修改时间 */,
        checkInTime: "" /** 修改时间 */,

        vehicleCabinets: [],
      },
      rules: {
        cabinetNumberPage: [
          {
            required: true,
            message: "请输入柜号",
            trigger: "blur",
          },
        ],
        operateType: [
          {
            required: true,
            message: "请选择作业类型",
            trigger: "change",
          },
        ],
        passType: [
          {
            required: true,
            message: "请选择操作类型",
            trigger: "change",
          },
        ],
        estimatedArrivalTime: [
          {
            required: true,
            message: "请选择预约到达时间",
            trigger: "change",
          },
        ],
      },
      imageUrl: "",
      text: "",
      fileUploadHeaders: {},
    };
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
    // ticket字段
    let userInfo = Cache.get("CACHE_USER_INFO");
    if (userInfo && userInfo.access_token) {
      this.fileUploadHeaders = {
        ticket: userInfo.access_token,
      };
    } else {
      this.fileUploadHeaders = {};
    }
  },
  methods: {
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    beforeRemove(file, fileList) {
      return true;
    },
    handleBeforeUpload(file) {
      console.log("-file.type:-", file.type);
      let isLt5M = file.size / 1024 / 1024 <= 5;
      let isImg = false;
      if (["image/png", "image/jpg", "image/jpeg"].indexOf(file.type) == -1) {
        isImg = false;
      } else {
        isImg = true;
      }
      if (!isImg) {
        this.$message.error("图片类型错误,只能是png/jpg中的一种");
        this.imageUrl = "";
      }
      if (!isLt5M) {
        this.$message.error("上传OCR图片大小不能超过 5MB!");
      }
      return isImg && isLt5M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上传 1 个文件！`);
    },
    handleRemove(file, fileList) {
      console.log("Remove:", file, fileList);
    },
    onRemoveFile(file) {
      this.imageUrl = "";
    },
    handleFileSuccess(response, file, fileList) {
      console.log("-handleFileSuccess-");
      console.log("-response:-", response);
      console.log("-file:-", file);

      if (response && response.success) {
        this.$message({
          message: "解析成功",
          type: "success",
          duration: 1000,
        });
        console.log("-解析内容:-", response.returnObj);
        this.text = response.returnObj.scanOCR;
        this.imageUrl = response.returnObj.fileCode;
        this.recognizeInfo = Object.assign(
          this.recognizeInfo,
          response.returnObj.reservationInfo
        );
        console.log("-this.recognizeInfo:-", this.recognizeInfo);
        if (response.returnObj.reservationInfo.vehicleCabinets.length > 0) {
          let cabinetArr = this.recognizeInfo.vehicleCabinets;
          let cabinetNumberArr = [];
          let waresNameArr = [];
          let waresCountArr = [];
          let waresWeightArr = [];
          cabinetArr.forEach((item) => {
            cabinetNumberArr.push(item.cabinetNumber);
            waresNameArr.push(item.waresName);
            waresCountArr.push(item.waresCount);
            waresWeightArr.push(item.waresWeight);
          });
          this.recognizeInfo.cabinetNumberPage = cabinetNumberArr.join(","); // 柜号
          console.log("0--柜号:-", this.recognizeInfo.cabinetNumberPage);
          this.recognizeInfo.waresName = waresNameArr.join(","); // 货物名称
          this.recognizeInfo.waresCount = waresCountArr.join(","); // 货品数量
          this.recognizeInfo.waresWeight = waresWeightArr.join(","); // 货品重量
        } else {
          this.recognizeInfo.cabinetNumberPage = ""; // 柜号
          console.log("-1-柜号:-", this.recognizeInfo.cabinetNumberPage);
          this.recognizeInfo.waresName = ""; // 货物名称
          this.recognizeInfo.waresCount = ""; // 货品数量
        }
      } else {
        this.$message({
          message: response.msgContent,
          type: "error",
          duration: 1000,
        });
        this.imageUrl = "";
      }
    },
    handleRestForm() {
      this.recognizeInfo = {
        appointmentId: null,
        appointmentUuid: null /**车辆预约UUID*/,
        driverId: null /**司机ID*/,
        driverName: "" /**姓名*/,
        phone: "" /**手机号码*/,
        vehicleId: null /**车辆ID*/,
        frontPlate: "", // 前车车牌
        trailerPlate: "", //后车车牌
        appointmentType: null /**进出类型：1：进门，2：出门*/,
        operateType: null /**操作类型：1：装货、2：卸货、3：过车*/,
        passType: null /**过车类型：1：倒入，2：倒出*/,
        appointmentPark: "" /**预约园区ID*/,
        estimatedArrivalTime: "" /**预计到达时间*/,
        custom: "" /**客户*/,
        cabinetNumber: "" /**货柜数量*/,
        cabinetNumberPage: "", // 页面展示的柜号
        waresName: "", // 货物名称
        waresCount: "", // 货品数量
        waresWeight: "", // 货品重量
        serialNumber: "" /**流水号*/,
        appointmentStatus: null, // 状态
        picture: "" /**司机照片*/,
        frontLicensePlatePicture: "" /**前车牌照片*/,
        trailerLicensePlatePicture: "" /**挂车牌照片*/,
        carPicture: "" /**车身照片*/,
        companyCode: "" /**公司编号*/,
        specialProductFlag: "" /**是否特殊商品 1：是；0：否*/,
        isPauseWork: "" /**是否暂停作业 1：是；0：否*/,
        dataSource: "" /**数据来源 1：客服录入；0：司机预约*/,
        refAppointmentUuid: "" /**倒柜车辆预约UUID*/,
        creator: "" /**创建人(登录账号)*/,
        createTime: "" /** 创建时间 */,
        modifier: "", // 修改人(登录账号)
        modifyTime: "" /** 修改时间 */,
        checkInTime: "" /** 修改时间 */,

        vehicleCabinets: [],
      };
      this.$nextTick(() => {
        this.$refs["refForm"].clearValidate();
      });
      this.text = "";
      this.imageUrl = "";
    },
    // 校验文件格式
    validFileFormat(file) {
      const isLt5M = file.size / 1024 / 1024 <= 5;
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const fileArr = ["bmp", "jpg", "png", "tif", "gif"];
      let isFile = null;
      fileArr.indexOf(type) === -1 ? (isFile = false) : (isFile = true);
      if (!isFile) {
        this.$message.error("文件格式不正确! ");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("文件大小不正确! ");
        return false;
      }
      return true;
    },
    // 文件导入操作
    // handleFileImport(file) {
    //   if (!this.validFileFormat(file)) {
    //     this.fileList = [];
    //     return false;
    //   } else {
    //     let formData = new FormData();
    //     formData.append("file", file.raw);
    //     // 调用导入接口
    //     this.$fetch(api.gasTruck.importGasDevice, formData).then((response) => {
    //       if (response.success) {
    //         this.$message({
    //           message: "导入文件成功",
    //           type: "success",
    //         });
    //         this.requestList();
    //       } else {
    //         this.$message({
    //           message: response.msgContent,
    //           type: "error",
    //         });
    //       }
    //       this.$refs.upload.clearFiles();
    //     });
    //   }
    // },
    // ocr识别操作
    ocrRecognizeOpt() {
      console.log("ocr识别操作");
    },
    // 转文本操作
    changeTextOpt() {
      console.log("转文本操作");
    },
    // 转图片操作
    changePictureOpt() {
      console.log("转图片操作");
    },
    // 保存文本操作
    saveTextOpt() {
      this.$refs.refForm.validate((res) => {
        if (res) {
          // let params = { ...this.recognizeInfo };
          // console.log("-this.recognizeInfo:-", this.recognizeInfo.entryDate);
          let params = { ...this.recognizeInfo };
          // 调用文本录入接口 拼接请求参数 cabinetNumber, waresCount, waresName, waresWeight
          params.vehicleCabinets = [
            {
              cabinetNumber: this.recognizeInfo.cabinetNumberPage,
              waresCount: this.recognizeInfo.waresCount,
              waresName: this.recognizeInfo.waresName,
              waresWeight: this.recognizeInfo.waresWeight,
            },
          ];
          this.$fetch(api.text.addEnter, params).then((res) => {
            if (res && res.success) {
              console.log("-解析内容:-", res.returnObj);
              this.$message({
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.handleRestForm();
              this.$emit("save-recognize-info", params);
            } else {
              this.$message({
                message: res.prompt,
                type: "error",
                duration: 2000,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.recognize-panel-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  .recognize-panel-left-box {
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .left-text-box {
      width: 100%;
      height: 85%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // align-items: center;
      /* 添加CSS隐藏文件列表 */
      // .upload-demo .el-upload-list {
      //   display: none;
      // }
      .upload-img-item {
        display: inline-block;
        width: 100%;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &:hover {
          .delete-icon {
            opacity: 1;
          }
        }

        .el-upload,
        .img-card,
        .img {
          width: 130px;
          height: 130px;
          line-height: 130px;
          // background-color: #0d121c;
        }

        .delete-icon {
          font-size: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 7%;
          left: 30%;
          width: 130px;
          height: 130px;
          // border-radius: 6px;
          opacity: 0;
          cursor: pointer;
          background-color: rgba($color: #000000, $alpha: 0.4);
          transition: all 0.2s;
          box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
        }

        .el-icon-delete {
          color: #fff;
        }
      }

      .avatar-uploader {
        /deep/.el-upload {
          border: 2px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 200px;
          height: 200px;
          line-height: 200px;
          text-align: center;
        }
        .avatar {
          width: 200px;
          height: 200px;
          display: block;
        }
      }
      .format-box {
        width: 100%;
        height: 50px;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 10%;
      }
    }
  }
  .recognize-panel-middle-box {
    width: 5%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .recognize-panel-right-box {
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-form-item {
      width: 100%;
      display: flex;
      :deep .el-form-item__content {
        width: calc(100% - 125px);
      }
      .el-input__inner {
        width: 100%;
      }
    }
  }
}
</style>
